const Skeleton = () => {
  return (
    <div className="animate-pulse" role="status">
      <div className="flex bg-neutral-100 pt-6 max-md:!w-full max-md:flex-col-reverse">
        <div className="flex w-1/2 flex-col items-start justify-end pb-[42px] pl-[120px] max-md:!w-full max-md:!items-center max-md:!justify-center max-md:!pl-0 max-md:!pt-[19px]">
          <div className="flex h-full min-w-[72px] items-center justify-center gap-4 rounded-md">
            <div className="border-border-moderate hidden h-8 w-[179px] rounded-md border bg-white md:!block"></div>
            <div className="h-8 w-[207px] bg-gray-200"></div>
          </div>
        </div>
        <div className="flex h-full w-full flex-col items-center justify-around gap-8 pb-[42px] md:!w-1/2 md:flex-row">
          <div className="h-[50px] w-[130px] rounded-md bg-gray-200"></div>
          <div className="h-[50px] w-[110px] rounded-md bg-gray-200"></div>
          <div className="h-[50px] w-[100px] rounded-md bg-gray-200"></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
